import * as React from 'react';

import { dayjst } from '@/lib/dayjst';
import { Content } from '@/pages/News/types';

import { NewIcon, PublishedAt, TimeWrapper } from './style';

interface TimeInfoProps {
  content: Content;
}

const NewTime = 60 * 60 * 24 * 3 * 1000; // 新着条件（3日） ms表記

const TimeInfo: React.FC<TimeInfoProps> = ({ content }) => {
  const time = dayjst(content.publishedAt || content.updatedAt);

  return (
    <TimeWrapper>
      <PublishedAt>{time.format('YYYY/M/D')}</PublishedAt>
      {dayjst().diff(time) < NewTime && <NewIcon />}
    </TimeWrapper>
  );
};

export default TimeInfo;
